// @ts-nocheck
import { Plugin } from '/Users/sunyt/Documents/vk/24day/24-kyber-portal/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','request','qiankun',],
});

export { plugin };
